module.exports = __webpack_public_path__ + "img/white-hat.0dc04366.svg";